import { useFormContext } from 'react-hook-form';

import type { GovernanceFormSchema } from '../schemas';

export const useGovernanceFormContext = () => {
  const context = useFormContext<GovernanceFormSchema>();

  return context;
};
